export default {
  namespaced: true,
  state: {
    menu: false,
  },
  getters: {
    menu(state) {
      return state.menu
    }
  },
  mutations:{
    CHANGE_MENU_STATE(state, val){
      state.menu = val
    },
  },
  actions:{
    openMenu(context){
      context.commit('CHANGE_MENU_STATE', true)
    },
    closeMenu(context) {
      context.commit('CHANGE_MENU_STATE', false)
    },
  },
}
